import React from 'react'
import styled from 'styled-components'
import { SvgAttr } from '../SvgAttr/SvgAttr'

export const IconPinterest = ({
  classes = '',
  styles,
  width = '40px',
  height = '40px',
  color = 'currentColor',
}) => {
  return (
    <Svg
      viewBox='0 0 72 72'
      xmlns='http://www.w3.org/2000/svg'
      version='1.1'
      className={classes}
      width={width}
      height={height}
      styles={styles}
    >
      <title>Pinterest</title>
      <Path
        color={color}
        d='M37.53,8.35l2.65.29c21.7,3.37,31.23,29.83,16.07,46.19-7.06,7.62-18.02,10.66-28.05,7.7.48-.93,1.06-1.8,1.51-2.74,1.6-3.32,2.15-7.19,3.12-10.73.09-.1.5.6.59.69,3.38,3.89,9.79,3.06,13.69.43,6.52-4.39,9.27-15.58,6.18-22.66-6.53-14.94-31.25-12.27-35.43,3.42-1.23,4.61-.43,11.49,4.13,14.07.68.39,1.9,1.01,2.31-.03.15-.38.74-2.67.73-3-.02-.52-.98-1.51-1.28-2.04-2.33-4.06-.62-10.09,2.39-13.37,5.94-6.47,19.68-5.81,21.46,4.1.94,5.2-1.11,15.39-7.16,16.84-2.61.63-5.59-.72-5.86-3.6-.22-2.33,1.81-6.79,2.31-9.35.58-2.97-.07-6.49-3.87-6.15-4.95.44-5.87,7.93-4.06,11.56l-3.76,16.06c-.23,1.74-.42,3.52-.23,5.27-.11.1-2.32-1.07-2.6-1.23-7.44-4.22-12.67-11.91-13.76-20.44l-.22-2.1c.05-1.18-.07-2.42,0-3.59.8-13.63,12.57-24.89,26.11-25.57h3.04Z'
      />
    </Svg>
  )
}

const Svg = styled(SvgAttr)`
  width: ${(props) => props.width};
  height: ${(props) => props.height};
  ${(props) => props.styles}
`

const Path = styled.path`
  transition: all 0.2s ease-in-out;
  fill: ${(props) => props.color};
`
